export default __webpack_public_path__ + "static/media/line.ce3565db.svg";